module.exports = __webpack_public_path__ + "img/mrtt.87c3a605.webp";